const companyNames = [
	"Acestrip",
	"Alphadom",
	"Baseace",
	"Bigis",
	"Canejoyhex",
	"Codegreen",
	"Conela",
	"Conholdings",
	"D-holdings",
	"Dentotech",
	"Dombase",
	"Duosanfax",
	"Fasezoodom",
	"Fincode",
	"Freecode",
	"Freshlane",
	"Goldentechi",
	"Grooveline",
	"Hotzacode",
	"Istech",
	"J-fan",
	"Lamcan",
	"Lamline",
	"Linematlab",
	"Mediait",
	"Medtechnology",
	"New-planet",
	"Quo-zim",
	"Quohouse",
	"Roundcom",
	"Sanviacane",
	"Soncan",
	"Stancone",
	"Tamp-trax",
	"Tancane",
	"Techilane",
	"Techitaxon",
	"Tondom",
	"Toughzone",
	"Tran-lab",
	"Triocane",
	"Tripplelane",
	"Tripplelex",
	"Trustline",
	"Ventophase",
	"Volcode",
	"Voltity",
	"Waredexon",
	"Yearlux",
	"Yeartech",
	"Zergoron",
	"Zonnix",
	"Zumstreet",
	"konkhow",
	"namflex",
	"quotelane",
	"zertechnology",
	"zumplanet"
];

const get = (excluding = undefined) => {
	const possibilities = companyNames.filter(e => e !== excluding);
	return possibilities[Math.floor(Math.random() * possibilities.length)];
};

export default get;



// WEBPACK FOOTER //
// ./src/companyNames.js